'use client'
import styled from '@emotion/styled'
import { entries } from './_hooks/entries'
import { OverviewEntry } from './OverviewEntry'
import { HeaderSection } from '../_components/HeaderSection'

export default function ClientPage() {
  return (
    <>
      <HeaderSection
        title="Bloggen"
        body="Här hittar du artiklar om allt som rör bostadsrättsföreningar och styrelsearbete."
      />
      <Container>
        <EntryContainer>
          {entries.map((entry) => (
            <OverviewEntry key={entry.slug} {...entry}>
              {entry.children}
            </OverviewEntry>
          ))}
        </EntryContainer>
      </Container>
    </>
  )
}

const Container = styled.div`
  margin-bottom: 10rem;

  font-size: 1.25rem;
`

const EntryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;

  padding: 6rem 15vw;

  @media (max-width: 1500px) {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  @media (max-width: 1300px) {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  @media (max-width: 1100px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`
